export function defaultIfNullish<T>(value: T, defaultValue: T): T {
  return !isNullOrUndefined(value) ? value : defaultValue;
}

export function findIndexInArray(array: any[], matchValue: any, key?: string) {
  return array.findIndex(item => (key ? item[key] === matchValue : item === matchValue));
}

export function isNullOrUndefined<T>(value: T) {
  return value === null || value === undefined;
}

export function deepMerge(obj1, obj2) {
  const result = { ...obj1 };

  for (const key in obj2) {
    if (obj2[key] && typeof obj2[key] === 'object' && !Array.isArray(obj2[key])) {
      result[key] = deepMerge(result[key] || {}, obj2[key]);
    } else {
      result[key] = obj2[key];
    }
  }

  return result;
}

export function safeParseJson<T = any>(val: any, fallback: T = null): any {
  if (typeof val !== 'string') {
    return val;
  }
  try {
    return JSON.parse(val);
  } catch (err) {
    console.error('Failed to parse JSON string:', err);
    return fallback;
  }
}
